import {
  AfterViewInit,
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { Router } from "@angular/router";
import { Subject, merge } from "rxjs";
import { debounceTime } from "rxjs/operators";
import { CartService } from "src/app/services/cart.service";
import { CartService as CartStoreService } from "src/app/services/cart/cart.service";
import { StoreService } from "src/app/services/store.service";

@Component({
  selector: "nav-cart-content",
  templateUrl: "./nav-cart-content.component.html",
  styleUrls: ["./nav-cart-content.component.scss"],
})
export class NavCartContentComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  private readonly onDestroy$ = new Subject<void>();
  @Output() closeEvent = new EventEmitter<boolean>();

  constructor(
    private router: Router,
    public _batsCart: CartService,
    public _storeCart: CartStoreService,
    private _store: StoreService
  ) {}

  get hasItems() {
    return !this._storeCart.isEmpty || this._batsCart.items.length;
  }

  get subtotal() {
    return this._storeCart.cart.total + this._batsCart.total;
  }

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    //Set max height, only if are more than 3 items
    merge(this._batsCart.carrito$, this._storeCart.cartChanges$)
      .pipe(debounceTime(100))
      .subscribe(() => {
        if (!this.hasItems) return;
        const list = <any>document.querySelector(".cart-content-items");
        const items = document.querySelectorAll(
          ".cart-content-item:nth-child(-n+3)"
        );
        let height = 0;
        items.forEach((x: any) => (height += x.offsetHeight + 1));
        list.style.maxHeight = height;
      });
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  removeItem(index: number) {
    this._batsCart.removeItem(index);
  }

  goCheckout() {
    this.router.navigate(["/checkout"]);
    this.close();
  }
  goShopping() {
    this.router.navigate(["/shopping"]);
    this.close();
  }
  goBatDetail(item: any) {
    if (item.linea === "Custom") return;
    this._store.batData = {
      id: item.modeloId,
      linea: item.lineaId,
      nombre: item.modelo,
    };
    this.router.navigate(["/store", item.lineaId, item.modeloId]);
    this.close();
  }
  goStoreDetail(id: number) {
    this.router.navigate(["article", id]);
    this.close();
  }
  close() {
    this.closeEvent.emit();
  }
}
